import { Form } from '@enterprise-ui/canvas-ui-react'

export const TextFilter = (props) => {
  return <Form.Field {...props} type="text" />
}
